import WidgetEntity from '../WidgetEntity';
import * as Widgets from "@mm/constants/widgets";

export default class SendDataWidget extends WidgetEntity {
  static make(pageId, sortOrder, kind, zapName, integrationType) {
    return {
      ...super.make(pageId, Widgets.SEND_DATA, '', sortOrder),
      config: {
        connection_webhook_id: '',
        resource_subscription_trigger_name: zapName,
        kind,
        integrationType,
      },
    }
  }
}
